import React from "react";

const DriveThruAffiliateHeader = ({
  gameName,
  logo,
  productUrl,
  anchorName,
  logoMaxWidth,
  logoStyle,
}) => {
  const label = `${gameName} - Available @ DriveThruRPG.com`;

  return (
    <a
      href={productUrl}
      name={anchorName || "pageTop"}
      style={{ textDecoration: "none" }}
      target="_blank"
      rel="sponsored noopener"
    >
      <img
        src={logo}
        style={{ maxWidth: logoMaxWidth || "200px", ...logoStyle }}
        title={label}
        alt={label}
      />
      <span
        style={{
          margin: "0 10px",
          color: "white",
          textDecoration: "none",
        }}
      >
        Available @
      </span>
      <img
        src="https://www.drivethrurpg.com/en/assets/common/dtrpg-logo-small.png"
        style={{ maxWidth: logoMaxWidth || "200px" }}
        title={label}
        alt={label}
      />
    </a>
  );
};

export default DriveThruAffiliateHeader;
